import {useDisclosure} from "@chakra-ui/react-use-disclosure";
import {Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay} from "@chakra-ui/modal";
import {ModalTitle} from "react-bootstrap";
import {useTranslations} from "next-intl";
import {DayHours} from "../../tools/groupHours";
import {useEffect, useState} from "react";
import {Button, HStack, Text, VStack} from "@chakra-ui/react";
import {EndTimePicker, StartTimePicker} from "../form/NextDayCheckbox";

export function TimePeriodPickerDialog(
    {text, initialValue, onSave}: {text: string, initialValue: DayHours|undefined, onSave: (time: number[]) => void}
) {

    const {isOpen, onOpen, onClose} = useDisclosure()
    useEffect(() => {
        if (initialValue) {
            onOpen()
        }
    }, [initialValue, onOpen]);



    const t = useTranslations("addbar")

    const [state, setState] = useState<DayHours>(initialValue ?? {
        start: undefined, end: undefined
    })

    useEffect(() => {
        if (initialValue) setState(initialValue)
    }, [initialValue])

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay zIndex={100}>
                <ModalContent>
                    <ModalHeader>
                        <ModalTitle>
                            {t("edit")} {text}
                        </ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <VStack align="start">
                            <Text>{t("time_from")}</Text>
                            <StartTimePicker value={state} onChange={setState}/>
                            <Text>{t("time_to")}</Text>
                            <EndTimePicker value={state} onChange={setState}/>

                        </VStack>
                    </ModalBody>
                    <ModalFooter>
                        <HStack>
                            <Button onClick={() => {
                                if (state.start !== undefined && state.end !== undefined) {
                                    onSave([state.start, state.end])
                                    onClose()
                                }
                            }
                            } isDisabled={state.start === undefined || state.end === undefined}>{t("save")}</Button>
                            <Button onClick={() => {
                                onClose()
                            }
                            }>{t("cancel")}</Button>
                        </HStack>
                    </ModalFooter>
                </ModalContent>
            </ModalOverlay>
        </Modal>
    )
}